// extracted by mini-css-extract-plugin
export var gif = "_kh-0";